import classNames from 'classnames';

import type { Template } from '../types';

const TEMPLATE_LABEL: Record<Template, string> = {
  search: 'Search',
  shopping: 'Shopping',
  pmax: 'Performance Max'
};

export const ALL_TEMPLATES: Template[] = ['search', 'shopping', 'pmax'];

interface TemplateTabsProps {
  selected: Template;
  // Account count per template — the number of audited accounts that actively run this
  // template family. Matches the platform-chip count semantics ("accounts in scope") so the
  // two filter rows tell a consistent story.
  activeAccountCountByTemplate: Record<Template, number>;
  onChange: (template: Template) => void;
}

export const TemplateTabs = ({
  selected,
  activeAccountCountByTemplate,
  onChange
}: TemplateTabsProps) => (
  <div className='template-tabs' role='tablist' aria-label='Audit templates'>
    {ALL_TEMPLATES.map(t => {
      const activeAccounts = activeAccountCountByTemplate[t] ?? 0;
      const disabled = activeAccounts === 0;
      const isSelected = t === selected;
      return (
        <button
          key={t}
          type='button'
          role='tab'
          aria-selected={isSelected}
          disabled={disabled}
          title={disabled ? 'No accounts run this campaign type' : undefined}
          className={classNames(
            'template-tabs__tab',
            isSelected && 'template-tabs__tab--active',
            disabled && 'template-tabs__tab--disabled'
          )}
          onClick={() => !disabled && onChange(t)}
        >
          <span className='template-tabs__label'>{TEMPLATE_LABEL[t]}</span>
          <span className='template-tabs__count'>{activeAccounts}</span>
        </button>
      );
    })}
  </div>
);
